import { gsap } from 'gsap'
import { getHeight } from '../library'
export default class HomePromo {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.promos = this.el.querySelectorAll('.promo-item')
    this.tallestBleed = 0
    this.screen = this.el.querySelector('[data-darken]')
    this.topPadding = 0
  }

  init() {
    if (this.screen) {
      this.topPadding = this.getTopPadding(this.screen)
    }
    this.promos.forEach((promo) => {
      this.findTallest(promo)
      promo.addEventListener('mouseenter', this.handleOver)
      promo.addEventListener('mouseleave', this.handleOut)
    })

    this.handleBoxTransform()
  }

  handleOver = (e) => {
    e.stopPropagation()
    const { currentTarget } = e
    const reveal = currentTarget.querySelector('[data-reveal]')
    const transformY = `-${getHeight(reveal)}`
    const t2 = gsap.timeline()
    t2.to(currentTarget, {
      y: transformY,
      duration: 0.2,
    })
  }

  handleOut = (e) => {
    e.stopPropagation()
    const { currentTarget } = e
    const t3 = gsap.timeline()
    t3.to(currentTarget, {
      y: 0,
      duration: 0.3,
    })
  }

  findTallest(el) {
    const bleedPortion = el.querySelector('[data-promo-item]')
    const shift = this.topPadding + getHeight(bleedPortion)
    if (shift > this.tallestBleed) {
      this.tallestBleed = shift
    }
    return false
  }

  getTopPadding(el) {
    let value = window
      .getComputedStyle(el, null)
      .getPropertyValue('padding-top')
    value = parseInt(value)
    return value
  }

  handleBoxTransform() {
    const t1 = gsap.timeline({ duration: 2 })
    const y = `-${this.tallestBleed}`
    t1.to(this.el, {
      opacity: 1,
      y,
    })
    t1.fromTo(
      this.promos,
      {
        opacity: 0,
        y: 50,
      },
      {
        opacity: 1,
        stagger: 0.1,
        y: 0,
      },
      '<',
    )
  }
}
